<template>
<AdminMember
  ref="member"
  @click="onSearch(true)"
>
  <b-table
    @scroll="onScroll"
    ref="wrap"
    style="height: 500px; margin-bottom: 0; max-height: 500px"
    head-variant="my-db"
    :items="items"
    :fields="fields"
    class="mt-3"
    sticky-header
    no-border-collapse
    bordered>
    <p class="p-center" v-if="items.length === 0">{{$t('common.empty_hint')}}</p>
  </b-table>
  <b-button class="btn-member" @click="onDownloadExcel" style="margin-top: 5px;">
    {{$t('admin_member.export_excel')}}
  </b-button>
</AdminMember>
</template>
<script>
import AdminMember from './AdminMember'
import Utils from "../../../../config/utils";

export default {
  name: "AdminMemberDb",
  components: {
    AdminMember
  },
  data() {
    return {
      fields:[
        {key:"no",label:this.$t('admin_member.number'), class:'text-center item_label', thStyle:"width:12%"},
        {key:"group", label:this.$t('admin_member.affiliation'), class:'text-center item_label', thStyle:"width:35%"},
        {key:"name", label:this.$t('admin_member.name'), class:'text-center item_label', thStyle:"width:26%"},
        {key:"connect", label:this.$t('admin_member.contacts'), class:'text-center item_label', thStyle:"width:27%"},
      ],
      items: [],
      pageNum:1,
      loadingEnd:false,
      memberList:[],
    }
  },
  methods:{
    onScroll(){
      let wrap = this.$refs.wrap.$el;
      console.log(wrap.scrollHeight);
      console.log(wrap.scrollTop);
      console.log(wrap.clientHeight);
      if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
        if (!this.loadingEnd)
          this.onSearch();
      }
    },
    onSearch(clear = false) {
      if (!clear && this.loadingEnd) {
        return;
      }

      if (clear) {
        this.pageNum = 1;
      }

      Utils.requestGet(this.$c.API.Admin.findUserListByPhone, {
        phone: this.$refs.member.phone_num.replaceAll('-', ''),
        page: this.pageNum
      }).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.loadingEnd = result.data.count > result.data.list.length;
            this.pageNum = this.pageNum + 1;
            this.items = clear ? this.convert(result.data.list) : [...this.items, ...this.convert(result.data.list)];
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    convert(data){
      var return_array = [];
      for(let item of data){
        return_array.push({
          no: item.f_idx,
          group: item.f_affiliation,
          name: item.f_name,
          connect: Utils.formatPhoneNumber(item.f_phone),
        });
      }
      return return_array;
    },
    onDownloadExcel() {
      // if (this.state.keyword == '') {
      //   Toast.show(Langs.login.phone_placeholder);
      //   return;
      // }
      let keyword = this.$refs.member.phone_num.replaceAll('-', '');
      let fileName = 'made_member_list_' + keyword  + '_list.xls';
      let url = this.$c.API_URL + this.$c.API.Admin.downloadUserTable + '?type=' + this.myinfo.type;

      // let destPath = `${RNBackgroundDownloader.directories.documents}/${fileName}`;
      Utils.downloadExcel(url, fileName);
      // let task = RNBackgroundDownloader.download({
      //   id: fileName,
      //   url: url,
      //   headers: {
      //     'App-Access-Token': this.myInfo.accessToken
      //   },
      //   destination: `${RNBackgroundDownloader.directories.documents}/${fileName}`
      // }).begin((expectedBytes) => {
      //   console.log(`Going to download ${expectedBytes} bytes!`);
      // }).progress((percent) => {
      //   console.log(`Downloaded: ${percent * 100}%`);
      // }).done(() => {
      //   // console.log(destPath);
      //   Toast.show(destPath + " 에 저장되었습니다.");
      // }).error((error) => {
      //   console.log('Download canceled due to error: ', error);
      // });

    }
  },
  watch:{
  },
  mounted() {
    this.onSearch(true);
    this.$refs.wrap.$el.onscroll = this.onScroll;
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
::placeholder{
  color: $text!important;
}
.p-center{
  text-align: center;
  margin-top: 4em;
  font-size: 0.9em;
}

.btn-member{
  margin-top: 6px;
  height: 45px;
  background-color: #267fff;
  border-radius: 0;
  color: white;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
  width: 80%;
}
.item_link_label{color: #0840ba; font-size: 14px;text-decoration: underline; font-family: $korean_gd_15_r};



</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminMemberDb.vue